export default {
  lpStaking: {
    minimumAmount: "Minimum stake: {amount} USDT",
    amountTooLow: "Stake at least {amount} USDT",
    minimumLoading: "Loading minimum stake",
    minimumFailed: "Minimum stake unavailable. Please retry.",
    confirmationDelayed: "On-chain confirmation is still pending. Refresh the staking status manually; do not pay again.",
    statusUnknown: "Status unavailable",
    refreshStaked: "Refresh staking status",
    paid: "Staking confirmed",
    unpaid: "Unpaid",
    confirming: "Awaiting on-chain confirmation",
    contractPending: "LP contract pending deployment. Staking is unavailable.",
    orderInvalid: "Invalid order data. Check your staking records first.",
    walletRequired: "Connect your wallet first",
    wrongNetwork: "Switch to the correct network",
    accountChanged: "Wallet account changed. Please sign in again.",
    signatureRejected: "Wallet action cancelled",
    submitFailed: "Submission failed. Please retry.",
    retryHash: "Resubmit transaction Hash",
    hashRetryHint: "Transaction sent. Retry the Hash submission; do not pay again.",
    paymentUncertain: "Transaction status uncertain. Check your records before paying again.",
    orderNumber: "Order number",
    transactionHash: "Transaction Hash",
    refreshRecords: "Refresh",
    retry: "Retry",
    noRecords: "No records yet",
    recordsFailed: "Unable to load records. Please retry.",
    stakingIncome: "Staking earnings",
    loadMore: "Load more",
    ordersPending: "Staking records are temporarily unavailable",
    title: "LP Staking",
    staked: "Staked USDT",
    stakeUsdt: "Stake USDT",
    walletBalance: "Wallet USDT balance",
    refreshBalance: "Refresh wallet balance",
    amount: "Staking amount",
    amountPlaceholder: "Enter staking amount",
    amountHint: "Choose an amount or enter manually",
    confirm: "Confirm staking",
    stakingPending: "Staking coming soon",
    dataPending: "Data integration pending",
    unavailable: "Unavailable",
    balanceFailed: "Unable to load wallet balance. Please retry.",
    amountRequired: "Enter a staking amount",
    amountInvalid: "Enter a valid amount greater than 0",
    insufficient: "Insufficient wallet USDT balance",
    records: "My staking records",
    ranking: "Global staking totals",
    earnings: "Earnings records",
    recordsDescription: "Your individual staking records",
    rankingDescription: "Wallets sorted by cumulative staked amount",
    rankingHint: "Multiple stakes from one wallet are combined",
    earningsDescription: "View each earnings entry",
    back: "Back to LP Staking",
    recordLinks: "Record links",
  },
  确认: "Confirm",
  取消: "Cancel",
  选择语言: "Select Language",
  切换语言成功: "Language switched successfully",
  首页: "Home",
  采购: "Submit Order",
  团队: "Team",
  "交易进行中,请勿进行其他操作":
    "Transaction in progress. Please do not perform other operations",
  资金管理: "Fund",
  资金明细: "Fund Details",
  我的订单: "My Orders",
  订单详情: "Order Details",
  没有更多了: "No more",
  加载中: "Loading",
  代币价格: "Token Price",
  收益概览: "Earnings Overview",
  申购收益: "Subscription Earnings",
  分享收益: "Sharing Earnings",
  官方网站: "Official Website",
  官网: "Official Site",
  电报: "Telegram",
  推特: "Twitter",
  白皮书: "White Paper",
  申购金额: "Subscription Amount",
  请输入入金金额: "Please enter the deposit amount",
  快捷申购: "Quick Subscription",
  申购比例: "Subscription Ratio",
  赠币数量: "Bonus Token Quantity",
  立即申购: "Subscribe Now",
  更多: "More",
  订单: "Order",
  分红中: "Dividend in Progress",
  已完成: "Completed",
  累计分红: "Dividends",
  申购信息: "Subscription Information",
  兑换数量: "Exchange Quantity",
  赠币数量: "Bonus Token Quantity",
  开始时间: "Start Time",
  提现成功: "Withdrawal Successful",
  确认: "Confirm",
  订单编号: "Order Number",
  团队数据总览: "Team Data Overview",
  我的推广链接: "My Referral Link",
  复制: "Copy",
  "分享此链接邀请好友加入团队，获取推广奖励":
    "Share this link to invite friends to join the team and get referral rewards",
  团队业绩: "Team Performance",
  当前等级: "Current Level",
  今日收益: "Today's Earnings",
  申购收益: "Subscription Earnings",
  分享收益: "Sharing Earnings",
  团队用户: "Team Users",
  有效团队: "Valid Team",
  有效用户: "Valid Users",
  无效团队: "Invalid Team",
  直推用户: "Direct Referral Users",
  有效直推: "Valid Direct Referrals",
  无效直推: "Invalid Direct Referrals",
  资产余额数据概览: "Asset Balance Overview",
  提现: "Withdraw",
  选中币种: "Selected Token",
  请输入入金金额: "Please enter the deposit amount",
  提现数量: "Withdrawal Quantity",
  确认提现: "Confirm Withdrawal",
  资金明细: "Fund Details",
  分红收入: "Dividend Income",
  直推奖励: "Direct Referral Reward",
  团队奖励: "Team Reward",
  申购金额: "Subscription Amount",
  兑换数量: "Exchange Quantity",
  赠币数量: "Bonus Token Quantity",
  开始时间: "Start Time",
  立即申购: "Subscribe Now",
  确认: "Confirm",
  全部: "All",
  收入: "Income",
  支出: "Expense",
  请输入正确的金额: "Please enter the correct amount",
  申购成功: "Subscription Successful",
  申购失败: "Subscription Failed",
  提现失败: "Withdrawal Failed",
  提现信息: "Withdrawal Information",
  提现币种: "Withdrawal Token",
  提现数量: "Withdrawal Quantity",
  请选择币种: "Please select a token",
  钱包余额不足: "Insufficient wallet balance",
  余额不足: "Insufficient balance",
  提现手续费: "Withdrawal Fee",
  间推奖励: "Indirect Referral Reward",
  团队奖励: "Team Reward",
  提现失败退还: "Refund for Failed Withdrawal",
  ido申购: "IDO Subscription",
  ido申购赠送: "IDO Subscription Bonus",
  链式去中心化全球点火网络: "Chain-based Decentralized Global Ignition Network",
  协议永生: "Protocol Immortality",
  智能涌现: "Intelligent Emergence",
  财富觉醒: "Wealth Awakening",
  立即进入: "Enter Now",
  大区累计业绩: "Cumulative Performance of Large Area",
  小区累计业绩: "Cumulative Performance of Small Area",
  复制成功: "Copy Successful",
  复制失败: "Copy Failed",
  暂无数据: "No Data Available",
  当DeFi遇上自主型DAO: "When DeFi Meets Autonomous DAO",
  历史最高: "All-Time High",
  历史最低: "All-Time Low",
  当前价格: "Current Price",
  采购累计收益: "Cumulative Earnings from Order Submission",
  团队累计收益: "Cumulative Team Earnings",
  采购金额: "Submission Amount",
  快捷采购: "Quick Order Submission",
  请输入采购金额: "Please enter the order submission amount",
  采购比例: "Submission Ratio",
  采购信息: "Submission Information",
  进行中: "In Progress",
  已完成: "Completed",
  累计收益: "Cumulative Earnings",
  立即采购: "Submit Order Now",
  请输入提现数量: "Please enter the withdrawal quantity",
  提现确认: "Withdrawal Confirmation",
  "本次提现的链上Gas费需由您自行承担，点击确定将执行提现流程，届时提取的余额会被优先扣除":
    "The on-chain Gas fee for this withdrawal will be borne by you. Click OK to proceed with the withdrawal, and the withdrawn balance will be deducted first",
  "操作后无法撤销，请谨慎认购":
    "This operation cannot be undone. Please subscribe with caution",
  我再想想: "Let me think again",
  确认提现: "Confirm Withdrawal",
  余额不足: "Insufficient balance",
  直推奖励: "Direct Referral Reward",
  团队奖励: "Team Reward",
  提现失败退还: "Refund for Failed Withdrawal",
  平级收益: "Peer Earnings",
  每日释放: "Daily Release",
  提现TDL: "Withdraw TDL",
  采购失败: "Order Submission Failed",
  绑定邀请人: "Bind Referrer",
  采购成功: "Order Submission Successful",
  提现比例: "Withdrawal Ratio",
  入金支付说明: "Deposit Payment Instructions",
  "您的实际支付由两部分组成，根据当前支付比例计算":
    "Your actual payment consists of two parts, calculated based on the current payment ratio",
  支付TDL数量: "TDL Payment Quantity",
  入金数量: "Deposit Quantity",
  TDL支付比例: "TDL Payment Ratio",
  "注：支付比例由平台设定，可能随时调整":
    "Note: The payment ratio is set by the platform and may be adjusted at any time",
  我知道了: "I understand",
  支付USDT数量: "USDT Payment Quantity",
  USDT支付比例: "USDT Payment Ratio",
  TDL实时价格: "TDL Real-Time Price",
  请先连接TCC链: "Please connect to the TCC chain first",
  收益中: "Earnings in Progress",
  世界华人的GDT: "Worldwide Chinese GDT",
  当Defi遇上自主型DAO: "When Defi Meets Autonomous DAO",
  提现GGC: "Withdraw GGC",
  支付GGC数量: "GGC Payment Quantity",
  GGC支付比例: "GGC Payment Ratio",
  GGC实时价格: "GGC Real-Time Price",
  兑换: "Exchange",
  兑换比例: "Exchange Ratio",
  兑换数量: "Exchange Quantity",
  确认兑换: "Confirm Exchange",
  请输入兑换数量: "Please enter the exchange quantity",
  兑换失败退还: "Refund for Failed Exchange",
  兑换GGC: "Exchange GGC",
  请输入采购方式: "Please enter the order submission method",
  余额采购: "Balance Order Submission",
  钱包采购: "Wallet Order Submission",
  资产余额: "Asset Balance",
  资产明细: "Asset Details",
  余额支付: "Balance Payment",
  商城划转: "Shopping Mall Transfer",
  商城划转GGC: "Shopping Mall Transfer GGC",
  采购收益GGC: "Order Submission Earnings GGC",
  采购方式: "Order Submission Method",
  采购数量: "Order Submission Quantity",
  链上全球购余额: "On-chain Global Ignition Network Balance",
  全球购划转USDT: "Global Ignition Network USDT Transfer",
  全球购划转GGC: "Global Ignition Network GGC Transfer",
  生态合成: "Ecological Synthesis",
  合成数量: "Synthesis Quantity",
  合成方式: "Synthesis Method",
  快捷合成: "Quick Synthesis",
  合成比例: "Synthesis Ratio",
  点击更多更多订单里面还有: "Click more orders to view more",
  合成信息: "Synthesis Information",
  合成累计收益: "Synthesis Cumulative Earnings",
  合成累计收益: "Synthesis Cumulative Earnings",

  收益统计: "Earnings Statistics",
  请输入合成数量: "Please enter the synthesis quantity",
  请输入合成方式: "Please enter the synthesis method",
  合成说明: "Synthesis Instructions",
  "50％GGC": "50% GGC",
  "50％GGC价值U": "the U value of 50% GGC",
  GDT链GGC余额: "GGC Balance on GDT Chain",
  GDT链USDT余额: "USDT Balance on GDT Chain",
  支付GGC: "GGC Payment",
  支付USDT: "USDT Payment",
  获取钱包余额失败: "Failed to get wallet balance",
  全球购余额: "Global Shopping Balance",
  钱包余额: "Wallet Balance",
  全球购划转余额: "Global PurchaseTransferBalance",
  采购奖励USDT: "Order Submission Reward USDT",
  贸易额度奖励GGC: "Trade Reward Reward GGC",
  可变现GGC2数量: "Available GGC2 Quantity",
  警告: "Warning",
  "需配置与GGC价值相等的U合成 , 按双倍GGC数":
    "It is necessary to configure U synthesis equivalent to the value of GGC, and release it at twice the quantity of GGC",
  量释放: "Release Quantity",
  "需配置与GGC价值相等的U合成 , 按双倍GGC数量释放":
    "It is necessary to configure U synthesis equivalent to the value of GGC, and release it at twice the quantity of GGC",
  该项业务不为中国用户提供任何服务:
    "This service does not provide any services to Chinese users",
  "返回到钱包主页面,即可查阅到生态合成所支付的各项明细(包含：GGC、GDT、USDT)":
    "Click the wallet main page to view the details of the ecological synthesis payment. (GGC, GDT, USDT)",
};
